import { graphql } from '../graphql/generated';

export const DOCTOR_ECARD_ENABLED_QUERY = graphql(`
  query DoctorEcardEnabled($id: ID!) {
    doctor(id: $id) {
      id
      ecardEnabled
    }
  }
`);
